export default __webpack_public_path__ + "static/media/information.d0190d64.svg";